import { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';

interface SectionLabelProps {
  children: ReactNode;
}

/**
 * Abschnitts-Beschriftung. Design-Rollout 25.10.2026: Theme-Rolle `label`
 * (12/500 grau) statt 11px Grossbuchstaben mit Laufweite.
 */
const SectionLabel: FC<SectionLabelProps> = ({ children }) => (
  <Typography variant="label">
    {children}
  </Typography>
);

export default SectionLabel;
